/**
 * @file Redirects the current path's index route to a nested child path.
 */
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

type Props = {
  to: string;
};

/**
 * Redirects from the current index path to its given child path.
 */
const IndexRedirect = ({ to }: Props): null => {
  const navigate = useNavigate();

  const { pathname: path } = window.location;

  useEffect(() => {
    navigate(`${path}/${to}`.replace("//", "/"));
  });

  return null;
};

export default IndexRedirect;
